<template lang="pug">
.delete-confirmation-details
  .text-lg.font-medium {{ $t('delete_confirmation', { text: $t('item').toLowerCase() }) }}
    v-card.round-md.pa-4.mt-4(v-if="selectedDiagnose" outlined color="neutral300")
      .text-sm {{ selectedDiagnose.value }}
    .text-md.mt-4 {{ $t('item_delete_confirmation_description_primary', { item: $t('item') }) }}
    .text-md {{ $t('item_delete_confirmation_description_secondary') }}
</template>

<script>
export default {
  props: {
    selectedDiagnose: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>